import { HStack, Icon, Text } from '@chakra-ui/react';
import { BsDot } from 'react-icons/bs';
import { ListItemBlockViewProps, BlockItemViewProps } from '../../../../view';
import { ReportingViewBaseConfig } from '../../../../base';

export function createDocumentListItemView(
    config: ReportingViewBaseConfig & {
        BlockItem: React.FC<BlockItemViewProps>;
    }
): React.FC<ListItemBlockViewProps> {
    const { BlockItem } = config;

    return (props) => {
        return (
            <BlockItem {...props.block}>
                <HStack spacing={3} color="whiteAlpha.700" align="start">
                    <Icon fontSize="2xl" as={BsDot} />
                    <Text>{props.children}</Text>
                </HStack>
            </BlockItem>
        );
    };
}
